module.exports = __webpack_public_path__ + "static/media/SCBthirdParties.c8307b79.svg";